import { AxiosError } from 'axios'
import { captureError } from 'conversations/utils/logRocket'
import config from 'shared/config'

import { createAuthedHttpClient } from '@driftt/web-auth'

import { getAppServices } from './services'
import { INVALID_USER } from './utils/auth'
import logger from './utils/logger'

const unauthedErrorHandler = (error?: AxiosError) => {
  if (error?.response?.status === 403 && error?.response?.data?.key === INVALID_USER) {
    logger.warn(`Received 403 from ${error?.response?.config.baseURL}. Logging out.`)
    getAppServices().auth.logout()
  }
}

const rateLimitErrorHandler = (error?: AxiosError) => {
  if (error?.response?.status === 429) {
    captureError(error, 'API limit reached')
    logger.warn(`Received 429 from ${error?.response?.config.baseURL}`)
  }
}

const responseErrorHandlers = [unauthedErrorHandler]

export const CustomerApi = createAuthedHttpClient({
  baseConfig: {
    baseURL: config.CUSTOMER_API,
  },
  responseErrorHandlers,
})

export const ConversationApi = createAuthedHttpClient({
  baseConfig: {
    baseURL: config.CONVERSATION_API,
  },
  responseErrorHandlers,
})

export const ContactApi = createAuthedHttpClient({
  baseConfig: {
    baseURL: config.CONTACTS_API,
  },
  responseErrorHandlers,
})

export const MessagingApi = createAuthedHttpClient({
  baseConfig: {
    baseURL: config.MESSAGING_API,
  },
  responseErrorHandlers,
})

export const InboxApi = createAuthedHttpClient({
  baseConfig: {
    baseURL: config.INBOX_API,
  },
  responseErrorHandlers: [...responseErrorHandlers, rateLimitErrorHandler],
})

export const AccountActivityApi = createAuthedHttpClient({
  baseConfig: {
    baseURL: config.ACCOUNT_ACTIVITY_API,
    timeout: 5000,
  },
  responseErrorHandlers,
})

export const AttachmentsApi = createAuthedHttpClient({
  baseConfig: {
    baseURL: config.ATTACHMENTS_API,
  },
  responseErrorHandlers,
})

export const LiveApi = createAuthedHttpClient({
  baseConfig: {
    baseURL: config.LIVE_API,
  },
  responseErrorHandlers,
})

export const MetricsApi = createAuthedHttpClient({
  baseConfig: {
    baseURL: config.METRICS_API,
  },
})

export const MeetingsApi = createAuthedHttpClient({
  baseConfig: {
    baseURL: config.MEETINGS_API,
  },
})

export const IntegrationsApi = createAuthedHttpClient({
  baseConfig: {
    baseURL: config.INTEGRATION_API,
  },
})

export const TargetingApi = createAuthedHttpClient({
  responseErrorHandlers,
  baseConfig: {
    baseURL: config.TARGETING_API,
  },
})

export const AccountsApi = createAuthedHttpClient({
  responseErrorHandlers,
  baseConfig: {
    baseURL: config.ACCOUNTS_API,
  },
})

export const TicketApi = createAuthedHttpClient({
  responseErrorHandlers,
  baseConfig: {
    baseURL: config.TICKET_API,
  },
})

export const TextMessagingApi = createAuthedHttpClient({
  responseErrorHandlers,
  baseConfig: {
    baseURL: config.TEXT_MESSAGING_API,
  },
})

export const RoutingApi = createAuthedHttpClient({
  baseConfig: {
    baseURL: config.ROUTING_API,
  },
})

export const ReportApi = createAuthedHttpClient({
  baseConfig: {
    baseURL: config.REPORT_API,
  },
})

export const NotificationsApi = createAuthedHttpClient({
  baseConfig: {
    baseURL: config.NOTIFICATIONS_API,
  },
})

export const UserActivityAPI = createAuthedHttpClient({
  baseConfig: {
    baseURL: config.USER_ACTIVITY_API,
  },
})
